//首页
export const h = {
    lang: "English",
    solution: "解决方案",
    isp: "运营商",
    enterprise: "企业",
    product: "产品",
    csa: "云快递",
    cxc: "云快线",
    vn: "多点组网",
    mobility: "移动应用",
    hardware: "硬件",
    gaa: "全球应用发布",
    customer: "客户",
    ccs: "客户案例分析",
    Financial: "金融业",
    Energy: "能源",
    Education: "教育行业",
    technology: "技术",
    wp: "资料",
    download: "应用下载",
    Support: "技术支持",
    cooperation: "合作申请",
    aboutUs: "关于我们",
    overview: "关于我们",
    et: "专家团队",
    awards: "奖项",
    news: "新闻资讯",
    //home
    ban1: "高性能",
    ban2: "高安全",
    ban3: "部署灵活",

    we: "我们是SD-WAN解决方案的领导者",
    wec:
        "我们建立先进、稳定、高速度、低延迟的WAN网络来帮助企业用户将注意力集中在他们的核心业务上",

    what: "什么是SD-WAN",
    whatc: "软件定义的网络",
    whatc1: "全球化的部署",
    whatc2: "提供企业专线连接",

    why: "为什么选择OBC",
    whyc: "高性能的数据传输",
    whyc1: "高度的安全保护",
    whyc2: "灵活的部署方式",

    di: "云快递业务",
    dic: "全球SaaS服务加速",
    dic1: "为应用提供保护",
    dic2: "可弹性的部署方式",

    xian: "云快线业务",
    xianc: "企业全球专线网络",
    xianc1: "企业数据传输加速",
    xianc2: "安全的数据通道",

    new: "新闻资讯",
    more: "更多",
    About: "视频介绍",

    flag: "多年技术沉淀",
    flag1: "超百人技术团队 提供专业服务",
    flag2: "网络节点 提供高速稳定网络",

    c4t1: "具有全球分布式的SD-WAN节点",
    c4t2: "智能路由技术为高可用提供技术保障",

    //底部
    rep: "深圳睿云网络人工智能技术有限公司",
    rep1: "版权所有 Copyright © 2021 OceanBlue Cloud. All rights reserved.",
    oshen: "深圳市欧深网络技术有限公司",
    net: "深圳睿网云联科技有限公司",

    // 我们的特点
    feature_t: "我们的特点",
    feature_1: "高性能",
    feature_2: "强安全",
    feature_3: "高可用",
    feature_4: "智能路由",
    feature_5: "简易使用",
    feature_6: "实时监控",
    feature_7: "数据分析",
    feature_8: "灵活部署",
    feature_d_1:
        "通过我们研发的FastIP技术，为不同地区间的节点提供高速的网络连接",
    feature_d_2: "高强度的数据加密技术将保证数据传输过程中的私密性",
    feature_d_3: "7*24小时保障的业务的可靠",
    feature_d_4:
        "全球分布的中转网络，以及AI控制器组建起一个快速响应的自适应网络",
    feature_d_5: "便于使用的控制台",
    feature_d_6: "实时掌握网络中各节点的状态，如有问题出现会及时发出通知",
    feature_d_7: "生成多种数据、报表和统计，以供企业IT人员分析使用",
    feature_d_8: "OBC产品可以被部署在任何有因特网的地方",
    //content2
    c2_t: "使用云应用快递服务提高应用效率",
    c2_c:
        "使用了OBC 云快递服务，企业云SaaS应用，如office365、Salesforce、sap等网络的性能将至数倍以上。",
    c2_t1: "使用云快线服务来建立全球企业网络连接",
    c2_c1:
        "通过OBC云快线服务，可以轻松高效地在全球不同地区的分公司之间部署专用网络。",
    //content3
    c3_t: "具有全球分布式的SD-WAN节点",
    c3_t1: "智能路由技术为高可用提供技术保障",
};

//关于我们
export const ab = {
    aboutUs: "关于我们",
    aboutUsCont:
        "我们建立了智能、稳定、高速、低延迟的广域网，帮助企业客户专注于他们的核心业务",
    concatUs: "联系我们",
    who: "我们是谁",
    whoCont:
        "几十年来企业通过部署DDN, Frame Relay和MPLS等广域网技术保证其商业数据的高质量转发。近年来随着云架构DC和混合架构DC的广泛应用，同时大数据和实时商业数据传输的需求越来越多，传统的专线连接技术已经不能满足客户快速部署商业应用和连接的需求。",
    whoCont1:
        "Oceanblue Cloud(深圳睿网云联科技有限公司)认为远距离和高质量的实时数据传输需求不应该成为驱动商业快速反应的瓶颈，OBC通过自有的先进FastIP技术可以帮助企业客户实现广域网连接的快速部署，不管是通过Internet还是MPLS，客户都能获得超高速的高质量数据传输服务。",
    whoCont2:
        "同时OBC致力于通过人工智能重新定义广域网网络连接，通过先进的分布式云端控制器实时感知网络健康状态并调度流量，实现了SLA的可视化。",

    bj: "中国 · 北京",
    sz: "中国 · 深圳",
    hk: "中国 · 香港",
    suzhou: "中国 · 苏州",
    db: "迪拜阿拉伯联合酋长国",
    singapore: "新加坡",
    cd: "中国 · 成都",
    locations: "公司地址",
    bjAdd: "北京市朝阳区朝外大街26号朝外MEN B座12G",
    szAdd: "广东省深圳市南山区西丽街道TCL国际E城E2栋6A01室",
    hkAdd: "香港旺角廣東道998號高明商業大廈15B",
    suzhouAdd: "苏州工业园区新平街388号腾飞科技园21幢5层04室",
    cdAdd: "中国（四川）自由贸易实验区成都高新区天府大道中段1号108单元1层7号",
    sh: "中国 · 上海",
    shAdd: "上海市浦东新区江耀路308号晶耀前滩T2栋813室",
    us: "美国 · 加利福尼亚",
    usAdd: "3230 E IMPERIAL HWY  SUITE 300 BREA, CA 92821, USA",
    jinan: "中国 · 济南",
    jinanAdd:
        "山东省济南市历下区经十路奥体金融中心C栋中国太平金融大厦11层1102-04单元",
    flb: "菲律宾",
    flbAdd:
        "18th Floor, ORE Central, 31st Street, Taguig, Metro Manila, Philippines",
    bx: "巴西",
    bxAdd:
        "Av dos Autonomistas4900, galpão C 03.0.0, km 18, Osasco-SP Brasil CEP: 06194-060",
};

//专家团队
export const et = {
    et: "专家团队",
    zhang: "张天成",
    zhangLabel: "系统分析师，软件构架师，CCIE, MSCE, JNCIS认证",
    zhangDesc:
        "15年ICT行业经验，曾就职于Luckypai、爱立信、华为、阿联酋电信等，负责大型网络构架设计，企业级网络应用排障等。",
    liu: "刘耀华",
    liuLabel: "网络构架师，软件构架师，研发专家",
    liuDesc:
        "20年系统构架设计、研发经验，曾就职于爱立信、三星、北电等500强企业，负责研发团队技术支撑及管理。",
    wen: "温航",
    wenLabel: "",
    wenDesc:
        "超过15年亚太、中东非国际市场销售经验，曾就职于西门子、华为，担任高级网络工程师以及业务销售。",
    jerry: "Jerry Lee",
    jerryLabel: "IT网络顾问, CCIE编号9631, CCIE, CCNP, MCSE, PMP认证",
    jerryDesc:
        "作为Linux基金会代表，多年来，Jerry Lee一直致力于全球IT业务孵化的咨询服务，并在尖端技术领域拥有丰富的业务经验。他曾任职于Bytemobile, Aryaka Networks, RightScale, Sylantro System, PacketFront, Datacraft Korea等公司。",
    yan: "杨旭",
    yanLabel: "IP网络工程师，CCIE，JNCIE认证",
    yanDesc:
        "曾就职于中兴、华为、阿尔卡特、Optus、Telstra等，超过15年骨干网运营、数据中心互联、企业网设计等ICT行业经验。",
    chen: "陈雷",
    chenLabel: "IP网络工程师，华为HCIE编辑，考官",
    chenDesc:
        "曾任职华为公司中东地区部，西欧地区部和全球IP网络市场营销总监，17年大型网络设计和实施经验，曾为VDF, Telefonica，KPN, H3G等运营商设计大型IP运营网络。",
    maggie: "刘洋",
    maggieLabel: "网络构架顾问",
    maggieDesc:
        "10年通信、ICT领域销售经验，负责企业网络构架解决方案，曾就职于中国电信国际公司、华为等。",
    long: "赵修龙",
    longLabel: "网络工程师，CCIE认证",
    longDesc:
        "15年网络技术支撑经验，负责网络运维知识培训，售前、售后技术支持，客户网络项目交付管理等。",
    quan: "龙泉",
    quanLabel: "wlan 研发总监",
    quanDesc:
        "擅长wlan soc、radio射频产品研发;业内最高集成度soc wlan模块:基于高通wlan芯片自主研发5mhz 10mhz频宽Wi-Fi驱动，抗干扰性强。6年wlan产品研发经验，配合烽火、hiwifi、九州、康力优蓝等行业客户研发设计wlan产品。",
    wu: "吴晓旭",
    wuLabel: "高级网络工程师 HCIE-R&S, HCIE-Security",
    wuDesc:
        "12年ICT工作经验，8年海外经历，曾就职于华为、施耐德，担任高级网络工程师职务，负责海外项目产品解决方案设计、项目交付及技术支撑等",
    guo: "郭钦洲",
    guoLabel: "PMP认证，数据分析师",
    guoDesc:
        "曾就职于大疆科技全球大客户团队，3年项目管理、数据分析、合作伙伴培训经验，软件工程学士学位。",
};

//Support
export const sp = {
    download: "资料下载",
    so: "服务网点",
    soc: "十余年行业专业服务经验",
    soc1: "7x24小时服务热线",
    soc2: "技术支持覆盖全球",
    soc3: "研发中心专家团队快速响应",
    //表单
    f_title: "免费试用",
    f_subTitle:
        "为您的全球分支机构获得高速与稳定的互联网连接，以及应用程序加速",
    f_first: "名",
    f_last: "姓",
    f_email: "Email",
    f_com: "公司名称",
    f_region: "区域/国家",
    f_tel: "电话",
    f_other: "用户是否遇到全球性的应用程序性能问题?",
    f_yes: "是",
    f_not: "否",
    f_more: "告诉我更多",
    f_submit: "提交",
};

//SD-WAN
export const sd = {
    w1: "为什么选择",
    wc:
        "随着企业宽带接入和互联网骨干网络容量的不断提高，在现有线路的基础上，SD-WAN提供了业界所寻求的低成本的网络连接方式。",
    mt: "传统的MPLS专线",
    mc:
        "在传统企业，电子邮件、文件分享、OA系统等应用都是通过集中部署方式实现的，传统私有网络和MPLS专线伴随着许多限制：部署复杂、CAPEX/OPEX昂贵、且缺少灵活性。通常来说，在不同地区的分支机构通过MPLS专线连接到总部数据中心，其结构如下图所示。",
    tt: "SD-WAN解决方案突破以上限制",
    sdc:
        "SD-WAN是基于控制面/数据面隔离、集中管理以及其他的SDN概念上实现的技术。它有助于企业通过一个简单的操作中心在全球范围内快速部署WAN网络。",
    ut: "你是否曾经、或是否准备使用SD-WAN",
    w2: "为什么选择OBC SD-WAN？",
    w2c:
        "我们建立先进、稳定、高速度、低延迟的WAN网络来帮助企业用户将注意力集中在他们的核心业务上",
    c1: "即插即用的交互方式",
    c1c: "所有配置全部由OBC后台控制器完成,无需现场调试",
    c2: "智能简洁的部署方式",
    c2c: "客户端零IT知识就可以使用支持",
    c2c1: "在第二三层的通信，对于客户现有的网络构造没有影响",
    c3: "全球覆盖",
    c3c: "全球只要有因特网覆盖的地方，就可以部署OBC方案",
    c4: "按需支付",
    c4c: "为客户节省支出，软硬件均免费提供",
    c4c1: "客户只需要支付订购费用",
    c5: "安全的数据通道",
    c5c: "OBC SD-WAN采用AES256加密技术全面保障客户的数据安全",
    c6: "终身硬件保障",
    c6c: "OBC硬件销售方保证超过99.9%的硬件可用性,承诺硬件终身免费更换",
};

//m100下载
export const m100 = {
    t: "M100客户端下载",
    c1: "可使用欧深网络所有服务的通用客户端",
    c2: "可支持所有主流移动及桌面设备",
    c3: "可通过任意设备享受安全便捷的网络接入",
    c4: 'AppStore 搜索"睿连终端M100"下载',
    c5: "立即下载",
    c6: "点击下载",
    t1: "NetTool下载",
    c7: "可诊断欧深网络服务的网络状况",
    n1: "安装须知",
    kylin_uos: "麒麟/统信",
    ipsec_download: "如需Ipsec,点击下载",
    c8: "鸿蒙NEXT(5.0.0)及以上版本通过应用市场搜索“鸿安通”下载",

    download_title: "应用下载",
    download_m100: "M100客户端",
    download_tip:
        "M100客户端支持VPN网络访问， 用户可使用多种操作系统，包括IOS, 安卓, Mac, Windows, 麒麟/统信, HarmonyOS",
    download_tip2: "云安通客户端支持VPN网络访问， 用户可使用安卓版本",
    download_start: "去下载",
    download_sase: "SASE客户端",
    download_sase_tip:
        "SASE客户端支持零信任网络访问，用户可使用多种操作系统，包括IOS, 安卓, Mac, Windows，HarmonyOS",
    download_nt: "NetTool客户端",
    download_nt_tip: "用于诊断欧深网路服务状况的工具",
    download_ipsec: "下载(IPSec)",
    download: "下载",
    download_kylin: "麒麟/统信",
    download_development: "研发中",
    download_intel_x86: " (Intel X86系列)",
    download_m: " (Apple M系列)",
    download_type: "选择适合您的产品版本",
    download_intel: "下载Intel芯片版",
    download_intel2: "适用 Intel x86 系列芯片",
    download_apple: "下载Apple芯片版",
    download_apple2: "支持 Apple M 系列芯片",
    download_type_tip: "如何确认芯片类型",
    download_type_tip2: "1、在左上角，打开Apple菜单选择“关于本机”",
    download_type_tip3: "2、在”处理器”或”芯片”中查看是“Intel“还是“Apple“",
    download_e_connect: "云安通",
    download_qr_title: "扫描二维码下载",
    download_qr_loading: "二维码生成中...",
    harmonyOS_tip: "鸿蒙NEXT(5.0.0)及以上版本",
    kylin_install_tip: "双击安装软件前请先在系统设置里设置允许第三方软件安装",
    kylin_install_how: "如何设置？",
    kylin_install_got_it: "我知道了",
};

//合作伙伴
export const pa = {
    t: "合作申请",
    c: "销售合作伙伴在行业或区域内从事OBC产品和解决方案销售",
    c1: "高性能",
    c2: "高安全性",
    c3: "高可靠性",
    c4: "智能路由",
    c5: "简单易用",
    c6: "实时监控",
    c7: "数据分析",
    c8: "部署灵活",
    f1: "合作类型",
    o1: "个人",
    o2: "企业",
    f2: "邮箱",
    f3: "姓名",
    f4: "企业邮箱",
    f5: "企业名称",
    f6: "营业登记类型",
    f7: "其他",
    f8: "联系人",
    f9: "电话",
    f10: "区域/国家",
    f11: "身份证正面照片",
    f12: "身份证反面照片",
    f13: "上传",
    f14: "营业登记图片",
    f15: "提交",
};

//设备
export const dv = {
    //rx
    rxs: "标准1U",
    rxu: "人",
    rxesim: "内置esim",
    rxno: "无",
    rxv100: "根据云主机配置",
    rxv100a: "云主机虚拟镜像",
    rxv100u: "公有云/私有云主机",
    rxv100t: "虚拟设备",
    rxv100t1: "虚拟边缘连接器",
    rxv100t2: "适用公有云 私有云平台",
    //r200
    rt: "标准1U的运营高级设备",
    rt1: "超高转发性能",
    rt2: "极速千兆网口 稳定组网",
    rd: "内存",
    rd1: "业务能力",
    rd2: "转发能力",
    rd3: "设备尺寸",
    rd4: "接口",
    rsk: "思科标准串口",
    ry: "应用场景",
    ryc: "企业总部",
    ryc1: "大型企业分支机构",
    ru: "使用人数",
    ruc: "10-300人",
    ra: "安装方式",
    rac: "1U标准机架安装",
    //d100
    dtt: "高性能中小型设备",
    dt1: "桌面型边缘连接器",
    dt2: "高转发性能 稳定可靠",
    duc: "10-50人",
    dac: "桌面/墙挂",
    ds: "串口",
    dy: "中小型企业",
    //S200
    st: "具备LTE功能的智能组网终端",
    st1: "超高性能WIFI",
    st2: "支持全球LTE作为WAN接入",
    sg: "全球",
    sy: "小型企业分支或",
    sy1: "零售门店",
    suc: "5-30人",
    //S50
    s5t: "精巧体积下的澎湃性能",
    s5t1: "完美适配小型组网场景的",
    s5t2: "智能设备",
    s5p: "电源接口",
    s5u: "小于30人",
    //a55
    at: "全球漫游的个人智能设备",
    at1: "全球E-SIM 多色可选",
    at2: "全球商旅人士的便携智能设备",
    aic: "全球漫游LTE (内置E-SIM))",
    auc: "连锁机构或SoHo",
    anc: "少于5人",
    aic: "桌面/手持",
    //比较
    dt: "机型比较",
    dn: "设备名称",
    das: "应用场景",
    dcn: "建议使用客户数",
};

//企业
export const ep = {
    t: "企业的IT服务正逐步向混合云迁移",
    c:
        "业务虚拟化已有比较成熟的方案，但网络连接只完成了局域网虚拟化，广域网连接仍停留在传统模式。广域网连接虚拟化，需要数据的控制，面向统一管理、调度、配置，数据的转发面向资源的集中和分享。",
    t1: "基于SD WAN架构的广域网部署，协助企业混合组网",
    c1:
        "通过多类型 SD-WAN CPE，经Internet连接云端POP点，实现快速、便捷、高质量、低成本混合组网。支持传统广域网组网向 SD-WAN 平滑演进，保护现有投资和业务一致性同时，助力企业数据中心逐步向云端迁移。",
    t2: "SD-WAN云快线解决方案 - 智能广域网",
    c2:
        "国内外分公司/分支机构/客户总部/数据中心之间的企业跨境组网，对应专线或MPLS，实现国内3层连接的高速低延迟混合云互联，建议每路高清会议使用4M及以上带宽，企业内部组网后，所有数据在内网传输，AES256 加密可保证数据安全，支持混合组网，充分利用现有投资，支持低成本扩展，SD-WAN集中控制系统，可将配置与安全策略统一推送到各接入点。",
    kt: "降低成本",
    kt1: "高质量",
    kt2: "快递交付",
    kt3: "易管理",
    kt4: "高可用",
    kt5: "灵活性",
    kc: "相比现有 MPLS/专线方案成本与 TCO 降低 80%",
    kc1:
        "整体组网基于 SD-WAN技术，但是全国骨干采用光纤传输（非公网），可以有效保证线路稳定性，所有连接（包括省级以下机构）能够实现近似MPLS 的线路质量",
    kc2: "一周之内开通业务，分支机构零配置",
    kc3: "全球分支机构统一管理配置、统一监控网络情况",
    kc4: "所有分支机构采用主备方案",
    kc5: "对比MPLS/专线，有更强的虚拟化能力，支持更丰富快速的组网方案",
};

//多点组网
export const vn = {
    t: "多点组网解决方案",
    c:
        "办公点只需要连接公网，即可组网，分支地区通过专线或宽带直接接入SD-WAN骨干接入点，西北地区使用 FastIP 技术优化公网传输后接入华中接入点或云中继点，省内使用 FastIP 技术优化公网传输后直连总部，支持设备与链路级的主备或双活模式。",
    cc:
        "无需更改现有系统架构，无需预先投资任何固定资产，节约建设与维护成本，在不增加成本的前提下，通过算法优化传输质量，部署周期快，全网统一可视化管理，支持混合组网，充分利用现有资源，AES-256 强加密方式，保证客户数据安全。",
    t1: "分支店面组网架构",
    c1:
        "支持多种接入模式，LTE，宽带及MPLS。根据各个分支机构使用不同类型设备支持不同的用户量。分支门店使用S/D系列设备。总部使用R设备。",
    u1: "10-300人",
    u2: "10-50人",
    u3: "5-30人",
};

//云快递
export const csa = {
    t: "OBC云快递业务改进Office 365性能",
    c:
        "随着企业宽带接入和互联网骨干网络容量的不断提高，通过OBC的云快递服务，能显著改善Office365操作流畅度。在现有线路的基础上，SD-WAN提供了业界所寻求的低成本网络连接方式，网络架构部署如下图所示：",
    t1: "OBC云快递业务提升了应用体验",
    c1:
        "每个分支机构都部署了OBC边缘连接器，用于连接OBC云快递服务，OBC云快递网络加速了数据传输到Office 365云服务器的进程，OBC云快递网络利用低延迟网络技术显著提升了应用体验。",
};
//云快线
export const cxc = {
    t: "云快线业务",
    t1: "OBC云连接覆盖于边缘连接器之间",
    c: "在总部和私有云节点之间提供云连接",
    c1: "在分部和公有云节点之间提供云连接",
    c2: "在总部和分部之间提供云连接",
    c3: "实现高速率低延迟的传输层第二或第三层的跨国连接",
};
//全球应用发布
export const gaa = {
    c:
        "基于OBC的全球分布节点，将您的网站发布至任意国家或地区，从而提升您的网站在全球的访问速度",
    c1: "同时支持静态资源与动态数据接口的加速，比CDN更胜一筹",
    c2: "使用服务后在不同国家之间做跨国访问时网速可实现",
    c3: "百倍增长",
};
//移动应用
export const mob = {
    t: "多平台客户端应用程序，提升移动办公、远程办公效率",
    c:
        "我们有windows、mac、android、ios等多平台客户端程序，可使用欧深网络所有服务的通用客户端，可支持所有主流移动及桌面设备，可通过任意设备享受安全便捷的网络接入",
    f: "使用服务后可在不同国家间做跨国高速访问",
    f1: "支持多种桌面与移动系统",
    f2: "一键登录高速安全的加密链路",
    f3: "支持企业账户无缝对接",
    c1: "前往下载",
};



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js